import { useState } from 'react';

const PNR_LENGTH = 6;
const TICKET_NO_MIN_LENGTH = 10;
const TICKET_NO_MAX_LENGTH = 14;
const TICKET_NO_PATTERN = /^[A-Za-z0-9]*$/;

export default function usePassengerDetails() {
  const [pnr, setPnr] = useState('');
  const [ticketNo, setTicketNo] = useState('');

  const trimmedPnr = pnr.trim();
  const trimmedTicketNo = ticketNo.trim();

  const isPnrValid = trimmedPnr.length === PNR_LENGTH;
  const isTicketNoValid = trimmedTicketNo.length >= TICKET_NO_MIN_LENGTH
    && trimmedTicketNo.length <= TICKET_NO_MAX_LENGTH
    && TICKET_NO_PATTERN.test(trimmedTicketNo);

  const isComplete = Boolean(isPnrValid && isTicketNoValid);

  return {
    values: { pnr, ticketNo },
    setPnr,
    setTicketNo,
    isPnrValid,
    isTicketNoValid,
    isComplete,
  };
}
